module.exports = __webpack_public_path__ + "media/img/apple-icon-6ed66e774d4e49256a3af837e207faab.png";